import { Select } from '@audio-network/componentlibrary'
import React, { FormEvent, useEffect, useState } from 'react'
import { useCurrentRefinements, useMenu } from 'react-instantsearch'

import { SelectFilterProps } from './SelectFilter.types'

const KeyFilter = ({
	attribute,
	curatedFacets,
	label,
	showEmpty = true,
	onSelect,
}: SelectFilterProps): JSX.Element => {
	const { items: menuItems, refine: menuRefine } = useMenu({
		attribute: attribute,
		sortBy: ['name'],
		limit: 100,
	})

	const { items: refinementItems, refine: refinementRefine } =
		useCurrentRefinements()

	const [selectedItem, setSelectedItem] = useState('')
	const selectValue = (event: FormEvent): void => {
		if (onSelect) {
			onSelect()
		}
		const { value } = event.target as HTMLInputElement
		if (value === 'empty') {
			const currentRefinement = refinementItems?.find(
				(item) => item.attribute === attribute
			)?.refinements[0]
			if (currentRefinement) {
				refinementRefine(currentRefinement)
			}
		} else {
			// Prevent selecting the same value twice from turning the facet off
			if (!menuItems?.find((item) => item.value === value)?.isRefined) {
				menuRefine(value)
			}
		}
	}

	const options = []
	if (showEmpty) {
		options.push({
			label: '',
			value: 'empty',
		})
	}
	if (curatedFacets) {
		options.push(
			...curatedFacets?.map((item) => ({
				label: item.id,
				value: item.id,
			}))
		)
	} else {
		options.push(
			...menuItems?.map((item) => ({
				label: item.label,
				value: item.value,
			}))
		)
	}

	useEffect(() => {
		const newValue = refinementItems
			?.find((item) => item.attribute === attribute)
			?.refinements[0].value.toString()

		setSelectedItem(newValue ? newValue : '')
	}, [refinementItems, attribute])

	return (
		<div>
			<Select
				data-testid={`${label.replaceAll(' ', '')}_testid`}
				name={label.replaceAll(' ', '_')} //Blows up if name contains a space
				options={options}
				label={label}
				value={selectedItem}
				onChange={selectValue}
			/>
		</div>
	)
}

export default KeyFilter
